import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-toggle-active',
}

class ToolbarToggle extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            listing: null,
            map: null,
        }
    }

    prepare() {
        const pathName = null
        if (window.location.pathname == '/mapa-centra') {
            this.ref.map.classList.add(STATES.ACTIVE)
        } else {
            this.ref.listing.classList.add(STATES.ACTIVE)
        }
    }
}

export default ToolbarToggle
